import * as AT from "src/core/schedules/store/schedules.constants";
import { ISchedule } from "src/core/schedules/api/schedules.api";

export type ScheduleActions = ISetSchedule | IPurgeSchedules;

interface ISetSchedule {
  type: AT.SET_SCHEDULE;
  schedule: ISchedule;
}

export const setSchedules = (schedule: ISchedule): ISetSchedule => {
  return {
    type: AT.SET_SCHEDULE,
    schedule
  };
};

interface IPurgeSchedules {
  type: AT.PURGE_SCHEDULES;
}

export const purgeSchedules = (): IPurgeSchedules => {
  return { type: AT.PURGE_SCHEDULES };
};
